import {
  EMPTY_FETCH_CORPS_MEMBER,
  FETCH_CORPS_MEMBER_SUCCESS,

  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAILURE,

  AUTH_CM_GUID,
  AUTH_CM_GUID_SUCCESS,
  AUTH_CM_GUID_FAILURE,

  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  RESTORE_CORPS_MEMBER_DETAILS,

  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  CHANGE_PASSWORD_RESET,
  FETCH_CORPS_MEMBER_FAILURE,
  REGISTER_LGI_USER,
  REGISTER_LGI_USER_SUCCESS,
  REGISTER_LGI_USER_FAILURE,
  RESTORE_LGI_USER,
  FETCH_ALL_LGI_USERS,
  FETCH_ALL_LGI_USERS_SUCCESS,
  FETCH_ALL_LGI_USERS_FAILURE,
  RELOCATE_LGI,
  RELOCATE_LGI_SUCCESS,
  RELOCATE_LGI_FAILURE,
  ACTIVATE_LGI,
  ACTIVATE_LGI_SUCCESS,
  ACTIVATE_LGI_FAILURE,
  DEACTIVATE_LGI,
  DEACTIVATE_LGI_SUCCESS,
  DEACTIVATE_LGI_FAILURE,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
} from "../ActionTypes";

const INIT_STATE = {
  authUser: JSON.parse(localStorage.getItem("user")),
  token: false,
  loader: false,
  initURL: "",
  corpsmemberDetails: {},
  isLoading: true,

  loggingIn: false,
  isLoggedin: false, // loginSuccess: false,

  verifyingCmGuid: false,
  cmGuidVerified: false,
  verRequestMade: false,

  changingPassword: false,
  changePasswordSuccess: false,
  messageToUser: "",

  registeringLGI: false,
  registeredLGI: false,

  fetchingLGIUsers: false,
  LGIUsers: [],

  relocatingLGI: false,
  relocatedLGI: false,

  lgiActivated:false,
  activatingLGI:false,

  lgiDeactivated:false,
  deactivatingLGI:false,

  passwordReset:false,
  resettingPassword:false,
};

function UsersReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case LOGIN_USER: {
      return {
        ...state,
        loggingIn: true,
      }
    }

    case AUTH_CM_GUID: {
      return {
        ...state,
        verifyingCmGuid: true,
        verRequestMade: true,
      }
    }

    case AUTH_CM_GUID_SUCCESS: {
      const expirationTime = new Date().getTime() + 4.92 * 60 * 60 * 1000; // 4hrs 55mins from now (in milliseconds or nano - not so sure...)
      // const expirationTime = new Date().getTime() + 20000; // 20 secs from now (for test ooo)
      localStorage.setItem("user", JSON.stringify(action.payload));
      localStorage.setItem("expirationTime", expirationTime);

      return {
        ...state,
        verifyingCmGuid: false,
        cmGuidVerified: true,
        authUser: action.payload,
        loader: true,
        token: true,
        initURL: "/home/cmMgtModule/inCampTrainingForm",
      }
    }

    case AUTH_CM_GUID_FAILURE: {
      return {
        ...state,
        verifyingCmGuid: false,
        cmGuidVerified: false,
      }
    }


    case LOGIN_USER_SUCCESS: {
      const expirationTime = new Date().getTime() + 4.92 * 60 * 60 * 1000; // 4hrs 55mins from now (in milliseconds or nano - not so sure...)
      // const expirationTime = new Date().getTime() + 20000; // 20 secs from now (for test ooo)
      localStorage.setItem("user", JSON.stringify(action.payload));
      localStorage.setItem("expirationTime", expirationTime);

      return {
        ...state,
        authUser: action.payload,
        loader: true,
        token: true,
        initURL: "/home/dashboard",
        isLoggedin: true,
        loggingIn: false,
      };
    }

    case LOGIN_USER_FAILURE: {
      return {
        ...state,
        isLoggedin: false, // there was a failure
        loggingIn: false,
      }
    }
    case LOGOUT_USER: {
      localStorage.removeItem("user");
      localStorage.removeItem("expirationTime");
      return {
        ...state,
        authUser: {},
        token: false,
      };
    }
    case FETCH_CORPS_MEMBER_SUCCESS: {
      return {
        ...state,
        corpsmemberDetails: action.payload,
        isLoading: false,
      };
    }
    case FETCH_CORPS_MEMBER_FAILURE: {
      return {
        ...state,
        corpsmemberDetails: [],
        isLoading: false,
      };
    }
    case EMPTY_FETCH_CORPS_MEMBER: {
      return {
        ...state,
        corpsmemberDetails: {},
        isLoading: true,
      };
    }
    case RESTORE_CORPS_MEMBER_DETAILS: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case CHANGE_PASSWORD: return {
      ...state,
      changingPassword: true,
    }
    case CHANGE_PASSWORD_SUCCESS: {
      const userObj = JSON.parse(localStorage.getItem('user'))
      userObj.hasChangedPassword = true
      localStorage.setItem('user', JSON.stringify(userObj))

      return {
        ...state,
        changingPassword: false,
        changePasswordSuccess: true,
        messageToUser: "Kindly login using your new password!"
      }
    }
    case CHANGE_PASSWORD_FAILURE: return {
      ...state,
      changingPassword: false,
      changePasswordSuccess: false,
    }
    case CHANGE_PASSWORD_RESET: return {
      ...state,
      changingPassword: false,
      changePasswordSuccess: false,
      messageToUser: "",
    }
    case REGISTER_LGI_USER: {
      return {
        ...state,
        registeringLGI: true,
        registeredLGI: false,
      };
    }
    case REGISTER_LGI_USER_SUCCESS: {
      return {
        ...state,
        registeringLGI: false,
        registeredLGI: true,
      };
    }
    case REGISTER_LGI_USER_FAILURE: {
      return {
        ...state,
        registeringLGI: false,
        registeredLGI: false,
      };
    }
    case RESTORE_LGI_USER: {
      return {
        ...state,
        registeringLGI: false,
        registeredLGI: false,
        fetchingLGIUsers: false,
        LGIUsers: [],
        relocatingLGI: false,
        relocatedLGI: false,
        lgiActivated:false,
        activatingLGI:false,
        lgiDeactivated:false,
        deactivatingLGI:false,
        passwordReset:false,
        resettingPassword:false,

      };
    }
    case FETCH_ALL_LGI_USERS: {
      return {
        ...state,
        fetchingLGIUsers: true,
        LGIUsers: []
      };
    }
    case FETCH_ALL_LGI_USERS_SUCCESS: {
      return {
        ...state,
        fetchingLGIUsers: false,
        LGIUsers: action.payload
      };
    } case FETCH_ALL_LGI_USERS_FAILURE: {
      return {
        ...state,
        fetchingLGIUsers: false,
        LGIUsers: []
      };
    }
    case RELOCATE_LGI: {
      return {
        ...state,
        relocatingLGI: true,
        relocatedLGI: false,
      };
    }
    case RELOCATE_LGI_SUCCESS: {
      return {
        ...state,
        relocatingLGI: false,
        relocatedLGI: true,
      };
    }
    case RELOCATE_LGI_FAILURE: {
      return {
        ...state,
        relocatingLGI: false,
        relocatedLGI: false,
      };
    }
    case ACTIVATE_LGI: {
      return {
        ...state,
        lgiActivated:false,
        activatingLGI:true,
      };
    }
    case ACTIVATE_LGI_SUCCESS: {
      return {
        ...state,
        lgiActivated:true,
        activatingLGI:false,
      };
    }
    case ACTIVATE_LGI_FAILURE: {
      return {
        ...state,
        lgiActivated:false,
        activatingLGI:false,
      };
    }
    case DEACTIVATE_LGI: {
      return {
        ...state,
        lgiDeactivated:false,
        deactivatingLGI:true,
      };
    }
    case DEACTIVATE_LGI_SUCCESS: {
      return {
        ...state,
        lgiDeactivated:true,
        deactivatingLGI:false,
      };
    }
    case DEACTIVATE_LGI_FAILURE: {
      return {
        ...state,
        lgiDeactivated:false,
        deactivatingLGI:false,
      };
    }
    case RESET_PASSWORD: {
      return {
        ...state,
        passwordReset:false,
        resettingPassword:true,
      };
    }
    case RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        passwordReset:true,
        resettingPassword:false,
      };
    }
    case RESET_PASSWORD_FAILURE: {
      return {
        ...state,
        passwordReset:false,
        resettingPassword:false,
      };
    }
    default:
      return state;
  }
}

export default UsersReducer;
